import React, { useEffect, useState, useContext } from "react";
import styles from "./EditAdminUserModal.module.css";
import {UserContext} from '../../../context/UserContext';
import {FaChevronDown} from "react-icons/fa";
import {formatPhone} from "../../../utils/PhoneUtils";
import {editMasterUserFromDatabase} from "../../../hooks/User";
import {getclientsFromDatabase} from "../../../hooks/Store";
import {handleUserRole} from "../../../utils/UserRole";
import {getClients} from "../../../data/clients/repository/ClientsRepository";

function Modal({ closeModal }) {
  const {selectedUser, editUser} = useContext(UserContext);
  const [name, setName] = useState(selectedUser?.name || "");
  const [role, setRole] = useState(selectedUser?.role || "");
  const [selectedUserRole, setSelectedUserRole] = useState(selectedUser != null ? handleUserRole(selectedUser?.role) : "Selecione a função do usuário");
  const [username, setUsername] = useState(selectedUser?.username || "");
  const [password, setPassword] = useState("***********" || "");
  const [phone, setPhone] = useState(selectedUser?.phone || "");
  const [access, setAccess] = useState(selectedUser?.access || "");
  const [clientId, setClientId] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [isUserRoleDropdownOpen, setIsUserRoleDropdownOpen] = useState(false);
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const toggleUserRoleDropdown = () => { setIsUserRoleDropdownOpen(!isUserRoleDropdownOpen) };
  const toggleClientDropdown = () => { setIsClientDropdownOpen(!isClientDropdownOpen) };

  const handleUserRoleSelect = (role) => {
    setSelectedUserRole(role);
    switch (role) {
      case "Master/Admin":
        setRole("MASTER");
        setAccess("PANEL_ADMIN_ACCESS");
        break;
      default:
        setRole("");
        break;
    }
  };

  const handleToggleclientselection = (client) => {
    setSelectedClients((prevSelectedClients) => {
      if (prevSelectedClients.some((c) => c.id === client.id)) {
        return prevSelectedClients.filter((c) => c.id !== client.id);
      } else {
        return [...prevSelectedClients, client];
      }
    });
  };

  const handleSelectClient = ( client ) => {
    setSelectedClient(client.name);
    setClientId([client.id]);
  };

  useEffect(() => {
    const fetchClients = async () => {
      const clientData = await getClients();
      if (clientData) {
        setClients(clientData?.clients ?? []);
      }
    };
    fetchClients();
  }, []);

  const handlePhoneChange = (e) => {
    const rawValue = e.target.value;
    const formattedPhone = formatPhone(rawValue);
    setPhone(formattedPhone);
  };

  const handleEditUser = async () => {
    const userData = {
      id: selectedUser.id,
      name,
      username,
      password,
      phone,
      role,
      access
    };

    const response = await editMasterUserFromDatabase(clientId, userData);
    if (response) {
      editUser(true);
      closeModal();
    } else {
      editUser(false);
    }
  };

  const renderclientsDropdown = () => {
    return (
      <>
        <button 
          type="button" 
          onClick={ toggleClientDropdown } 
          className={styles.dropdownButton}> { selectedClient } <FaChevronDown className={styles.icon} /> 
        </button>  
      </>
      )
  };
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>
            <label>
              <span>Nome</span>
              <input
                type="text"
                required
                placeholder="Digite o nome do usuário"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </label>

            <label>
              <span>Login</span>
              <input
                type="text"
                required
                placeholder="Digite o login do usuário"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </label>

            <label>
              <span>Senha</span>
              <input
                type="password"
                required
                placeholder="Digite a senha do usuário"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>

            <label>
              <span>Telefone</span>
              <input
                type="text"
                required
                placeholder="Digite o telefone do usuário"
                value={phone}
                onChange={handlePhoneChange}
              />
            </label>

            <label>
              <span>Função do Usuário</span>
              <div className={styles.dropdown}>
                <button type="button" onClick={ toggleUserRoleDropdown } className={styles.dropdownButton}>
                  { selectedUserRole } <FaChevronDown className={styles.icon} />
                </button>

                {isUserRoleDropdownOpen && (
                  <div className={styles.dropdownContent}>
                    <div onClick={() => handleUserRoleSelect("Master/Admin")}>Master/Admin</div>
                  </div>
                )}
              </div>
            </label>
            <label>
              <span>Cliente</span>
              <div className={styles.dropdown}>
                { renderclientsDropdown() }
                { isClientDropdownOpen ? (
                  <div className={styles.dropdownContent}>
                    {clients.map((client) => (
                      <div key={client.id} onClick={() => handleSelectClient(client)}>
                        {client.name}
                      </div>
                    ))}
                </div>
              ): null}
              </div>
            </label>
          </form>
        </div>

        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ handleEditUser }>Editar Usuário</button>
          <button onClick={closeModal} className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
